import React from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

export default function CardSlot({ children, marginTop = 0}) {
  return (
    <Slot marginTop={marginTop}>
      {children}
    </Slot>
  )
}

const Slot = styled(Column)`
  background: ${colors.neutralLight};
  width: 100%;
  height: auto;
  border-radius: 12px;
  padding: 20px;
  margin-top: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;

  @media screen and (min-width: ${breakpoints.lg}) {
    margin-left: 1%;
    width: 49%;

    ${({marginTop}) => marginTop && `
      &:nth-child(1),
      &:nth-child(2) {
        margin-top: 0;
      }
      margin-top: 1%;
    `}
  }
`;
